import {useEffect,useRef,useState} from 'react';
import {traderAPI} from '../context/TraderAuthContext';
import {useWebSocket} from '../../context/WebSocketContext';
import {watchLiveRefresh} from '../../hooks/liveRefresh';

const intervals={'1m':60,'5m':300,'15m':900,'30m':1800,'1H':3600,'4H':14400,'1D':86400,'1W':604800};
const append=(rows,quote,period)=>{
  const price=Number(quote?.bid),stamp=Date.parse(quote?.price_observed_at)/1000;
  if(!Number.isFinite(price)||price<=0||!Number.isFinite(stamp)||quote?.quote_available===false)return rows;
  const time=Math.floor(stamp/period)*period,last=rows.at(-1);
  if(last&&last.time>time)return rows;
  if(last?.time===time)return [...rows.slice(0,-1),{...last,high:Math.max(last.high,price),low:Math.min(last.low,price),close:price}];
  return [...rows,{time,open:price,high:price,low:price,close:price,volume:0}].slice(-1000);
};
export const useAccountPriceHistory=(symbol,timeframe,quote)=>{
  const enabled=Boolean(quote?.account_price_history),version=quote?.manual_adjustment?.version||0;
  const {isConnected}=useWebSocket();
  const latest=useRef(quote);latest.current=quote;
  const key=`${symbol}:${timeframe}:${version}`;
  const [state,setState]=useState({key:'',candles:[],loading:false,error:false});
  useEffect(()=>{
    if(!enabled)return;
    let alive=true,busy=false;const controller=new AbortController();
    const load=async()=>{
      if(busy)return;busy=true;
      try{const {data}=await traderAPI.get(`${process.env.REACT_APP_BACKEND_URL}/api/trader/account-price-history`,{params:{symbol,timeframe},signal:controller.signal});if(alive)setState({key,candles:append(data.candles,latest.current,intervals[timeframe]),loading:false,error:false});}
      catch{if(alive)setState(current=>({...current,key,loading:false,error:true}));}
      finally{busy=false;}
    };
    setState({key,candles:[],loading:true,error:false});load();const stop=watchLiveRefresh(load,15000);
    return()=>{alive=false;controller.abort();stop();};
  },[enabled,key,symbol,timeframe,isConnected]);
  useEffect(()=>{if(enabled)setState(current=>current.key!==key||current.loading?current:{...current,candles:append(current.candles,latest.current,intervals[timeframe])});},[enabled,key,timeframe,quote?.bid,quote?.price_observed_at]);
  return state.key===key?state:{candles:[],loading:enabled,error:false};
};